module.exports = __webpack_public_path__ + "img/invoice-de-male-wm-banner-rp.0db11b63.png";